import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { DecimalPipe, TitleCasePipe, DatePipe } from '@angular/common';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';
import { DrugGroupAkaImportsService } from 'app/core/services/drug-group-aka-imports.service';
import { DownloadService } from 'app/core/services/download.service';
import { DrugGroupAkaImport } from 'app/core/models/drug-group-aka-import.model';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';

@Component({
    selector: 'app-capture-admin-import-drug-group-akas-history',
    templateUrl: './capture-admin-import-drug-group-akas-history.component.html',
    imports: [ImportNavComponent,
              PaginationHeaderComponent,
              FaIconComponent,
              NgbDropdown,
              NgbDropdownToggle,
              NgbDropdownMenu,
              PaginationComponent,
              MatProgressSpinner,
              DecimalPipe,
              TitleCasePipe,
              DatePipe,
              BlankValueDashPipe]
})
export class CaptureAdminImportDrugGroupAkasHistoryComponent implements OnInit, OnDestroy {
  private drugGroupAkaImportsService = inject(DrugGroupAkaImportsService);
  private downloadService = inject(DownloadService);

  loading = false;
  drugGroupAkaImports: DrugGroupAkaImport[] = [];
  nextCheckTimeout = null;
  paging: LimitOffsetPaging;
  private destroyed = false;

  ngOnInit() {
    this.paging = LimitOffsetPaging.empty;
    this.paging.currentPage = 1;
    this.loadImports(this.paging.currentPage);
  }

  ngOnDestroy() {
    this.destroyed = true;
    clearTimeout(this.nextCheckTimeout);
  }

  failureMessageTitle(drugGroupAkaImport: DrugGroupAkaImport): string | null {
    if (drugGroupAkaImport.failed) {
      return drugGroupAkaImport.failureMessage;
    }

    return null;
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.loadImports(this.paging.currentPage);
  }

  onPageChange(page: number) {
    this.loadImports(page);
  }

  onCancelClick($event, drugGroupAkaImport: DrugGroupAkaImport) {
    $event.preventDefault();
    this.drugGroupAkaImportsService.
      cancel(drugGroupAkaImport.id).subscribe(drugGroupAkaImport => {
        const index = this.drugGroupAkaImports.findIndex(imp => imp.id === drugGroupAkaImport.id);

        if (index > -1) {
          this.drugGroupAkaImports[index] = drugGroupAkaImport;
          this.drugGroupAkaImports = [...this.drugGroupAkaImports];
        }
      });
  }

  onDownloadOriginalClick($event, drugGroupAkaImport: DrugGroupAkaImport) {
    $event.preventDefault();
    this.drugGroupAkaImportsService.get(drugGroupAkaImport.id).subscribe(drugGroupAkaImport => {
      const downloadUrl = drugGroupAkaImport.fileExpirableDownloadPath;
      this.downloadService.getDownloadUrl(downloadUrl).subscribe(expirableDownload => {
        this.downloadService.download(expirableDownload.url);
      });
    });
  }

  onDownloadSkippedClick($event, drugGroupAkaImport: DrugGroupAkaImport) {
    $event.preventDefault();
    this.drugGroupAkaImportsService.get(drugGroupAkaImport.id).subscribe(drugGroupAkaImport => {
      const downloadUrl = drugGroupAkaImport.skippedFileExpirableDownloadPath;
      this.downloadService.getDownloadUrl(downloadUrl).subscribe(expirableDownload => {
        this.downloadService.download(expirableDownload.url);
      });
    });
  }

  private loadImports(page, loading = true) {
    clearTimeout(this.nextCheckTimeout);
    this.loading = loading;
    const paging = { page, pageSize: this.paging.pageSize };
    this.drugGroupAkaImportsService.getList(paging).subscribe(result => {
      this.drugGroupAkaImports = result.drugGroupAkaImports;
      this.paging = result.meta.paging;
      this.loading = false;

      const anyActive: boolean = this.drugGroupAkaImports.some(drugGroupAkaImport => drugGroupAkaImport.active);

      if (anyActive && !this.destroyed) {
        clearTimeout(this.nextCheckTimeout);
        this.nextCheckTimeout = setTimeout(() => this.loadImports(this.paging.currentPage, false), 5000);
      }
    });
  }
}
